module.exports = __webpack_public_path__ + "img/item1.3fae72a2.svg";